import React, { Component } from "react";
import { connect } from "react-redux";
import Dashboard from "./Dashboard";
import translate from "react-i18next/dist/commonjs/translate";
import _ from "lodash";

class DashboardPage extends Component {
  render() {
    if (this.props.customerInformation.plusCustomer != null) {
      return (
        <div className="dashboard-page">
          <Dashboard {...this.props} />
        </div>
      );
    }

    return (
      <div className="dashboard-page">
        <section className="main-content" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    customerInformation: state.customerInformation,
    errors: state.errors
  };
}

export default translate("translations")(
  connect(mapStateToProps)(DashboardPage)
);



// WEBPACK FOOTER //
// ./src/dashboard/DashboardPage.js